import {observer} from 'mobx-react';
import {Select2} from 'shared/components';
import {types, endpoints} from 'main/tools';

const DimensionValueColumn = observer(({model, uiState, dimension}) => {
  const {employee} = uiState;

  if (model._type === types.TIME_OFF.ABSENCE || model._type === types.HOLIDAY) return null;

  const current = model.dimensionValueFor(dimension.id);

  if (!model.canPatch) {
    return <div>{current?.name}</div>;
  }

  return (
    <div className='relative'>
      <Select2
        key={model.inputKey}
        searchable
        allowClear
        onChange={e => {
          if (e.target.value === null) {
            uiState.updateEntryDimensionValue(model, dimension, null);
          } else {
            uiState.updateEntryDimensionValue(model, dimension, {
              id: e.target.value,
              name: e.target.options[e.target.selectedIndex].text,
              dimensionId: dimension.id
            });
          }
        }}
        defaultValue={current?.id}
        by='name'
        endpoint={endpoints.TIME_TRACKING.DIMENSION_VALUES.FOR_EMPLOYEE.with(employee.id, dimension.id)}
      >
        <option value={current?.id}>{current?.name}</option>
      </Select2>
    </div>
  );
});

export default DimensionValueColumn;
